import { createFileRoute } from "@tanstack/react-router"
import { LegalRefundPage } from "@/components/legal-pages"

export const Route = createFileRoute("/refund")({
  component: LegalRefundPage,
})
